import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import ErrorBoundary from "../../../../components/errorBoundary/errorBoundary";
import TotalSalesRevenueModule from "./totalSalesRevenueModule";
import { createReduxStore } from "./redux/store";

const TotalSalesRevenue = (props) => {
  return (
    <Provider store={createReduxStore("totalSalesRevenue")}>
      <ErrorBoundary {...props.notifications} moduleName={"totalSalesRevenue"}>
        <TotalSalesRevenueModule params={props.params} />
      </ErrorBoundary>
    </Provider>
  );
};

TotalSalesRevenue.propTypes = {
  notifications: PropTypes.objectOf(PropTypes.string),
  params: PropTypes.object
};

export default TotalSalesRevenue;
